class QuickViewModal extends HTMLElement {
    constructor() {
        super();
        this.modalContent = this.querySelector('.js-modal-content');
        this.modalContentWrapper = this.modalContent?.closest('.modal-content');
        this.showMorebtn = this.modalContent?.querySelector('.js-quick-view-details-link');
        this.currentProductUrl = null;

        document.addEventListener('click', (event) => {
            const button = event.target.closest('.js-quickview-btn')
            if (!button) return
            const productUrl = button.getAttribute('data-product-url');
            if (!productUrl) return;

            const isModalOpen = this.classList.contains('show');
            if (!isModalOpen || productUrl !== this.currentProductUrl) {
                this.showModal(button)
            }
        })
    }

    showModal(opener) {
        this.modalContent = this.querySelector('.js-modal-content');
        this.modalContentWrapper = this.modalContent?.closest('.modal-content');
        this.showMorebtn = this.modalContent?.querySelector('.js-quick-view-details-link');
        this.currentProductUrl = opener.getAttribute('data-product-url');

        const loader = document.querySelector('.js-quickview-loader');
        if (loader) window.Global.showLoader(loader);

        fetch(this.currentProductUrl)
            .then((response) => response.text())
            .then((responseText) => {
                const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
                this.initModal(this.productElement, opener, this.showMorebtn)

                this.preprocessHTML(this.productElement);
                HTMLUpdateUtility.setInnerHTML(this.modalContent, this.productElement.innerHTML);

                if (window.Shopify && Shopify.PaymentButton) {
                    Shopify.PaymentButton.init();
                }

                if (window.ProductModel) window.ProductModel.loadShopifyXR();

                this.preventVariantURLSwitching();

                window.pauseAllMedia();
            })
            .finally(() => {
                this.bindProductChangeCallbacks();
                if (this.modalContentWrapper) this.modalContentWrapper.classList.remove('h-600');
                let image = this.modalContent.querySelector('picture > img');
                if (image && !image.complete) {
                    image.addEventListener('load', () => {
                        if (loader) window.Global.hideLoader(loader);
                    })
                } else {
                    if (loader) window.Global.hideLoader(loader);
                }
                window.Global.addProductToRecentlyViewed()
            });
    }

    bindProductChangeCallbacks() {
        const swapProductUtility = this.querySelector('variant-selects')?.swapProductUtility;
        if (!swapProductUtility || swapProductUtility.__quickViewBound) return;

        swapProductUtility.__quickViewBound = true;
        swapProductUtility.addPreProcessCallback((newContent) => this.preprocessHTML(newContent));
        swapProductUtility.addPostProcessCallback(() => {
            this.modalContent = this.querySelector('.js-modal-content');
            this.modalContentWrapper = this.modalContent?.closest('.modal-content');
            this.bindProductChangeCallbacks();
        });
    }

    preprocessHTML(newProductElement = null) {
        if (newProductElement) this.productElement = newProductElement;

        if (this.modalContent) {
            [...this.modalContent.classList].forEach((klass) => {
                if (klass.startsWith('color-') || klass === 'gradient') this.modalContent.classList.remove(klass);
            });
        }

        this.productElement.classList.forEach((classApplied) => {
            if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
        });

        this.productElement.querySelectorAll('.quick-view-remove').forEach((el) => el.remove());
        this.productElement.querySelectorAll('[data-bs-toggle="modal"]').forEach((opener) => {
            opener.removeAttribute('data-bs-toggle');
            opener.style.cursor = 'default';
        });

        if (this.showMorebtn) {
            const checked = this.productElement.querySelector('variant-selects fieldset input[type="radio"]:checked');
            const nextHref = checked?.dataset?.productUrl || this.currentProductUrl;
            if (nextHref) this.currentProductUrl = nextHref;
            if (nextHref) this.showMorebtn.href = nextHref;
            this.showMorebtn.classList.remove('hidden');

            const infoSection = this.productElement.querySelector('[id^="ProductInfo"]');
            if (infoSection && !infoSection.contains(this.showMorebtn)) {
                infoSection.appendChild(this.showMorebtn);
            }
        }

        this.preventDuplicatedIDs();
        this.removeDOMElements();
        this.preventVariantURLSwitching();
    }

    initModal(modal, opener, button) {
        modal.classList.add('quick-view')
        // const gallery = modal.querySelector('.js-product-gallery') || modal.querySelector('.gallery-wrapper')
        // const image = gallery.querySelector('[data-glide-el="track"] li') || gallery.querySelector('[data-slide-id]')
        const hideEls = modal.querySelectorAll('.quick-view-remove')
        const galleryOpeners = modal.querySelectorAll('[data-bs-toggle="modal"]')
        const infoSection = modal.querySelector('[id^="ProductInfo"]')

        if (galleryOpeners.length) {
            galleryOpeners.forEach((opener) => {
                opener.removeAttribute('data-bs-toggle')
                opener.style.cursor = "default"
            })
        }

        if (button) {
            button.href = opener.getAttribute('data-product-url')
            button.classList.remove('hidden')

            if (infoSection) infoSection.appendChild(button)
        }

        // if (image) {
        //     gallery.querySelector(`.js-gallery-thumbnails`).parentNode?.remove()
        //     gallery.replaceWith(image.firstElementChild || image.firstChild)
        // }
        hideEls.forEach((el) => {
            el.remove()
        })
    }

    preventVariantURLSwitching() {
        const variantPicker = this.productElement.querySelector('variant-selects');
        if (!variantPicker) return;
        variantPicker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
    }

    preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
            element.dataset.originalSection = sectionId;
        });
    }
}

customElements.define('quick-view-modal', QuickViewModal);